import React, { useEffect, useState } from 'react';
import { TabsTimelineSub } from 'components';
import { tabs } from './tabs';
import { useSelector } from 'react-redux';

const BasicInfoBeneficiary = () => {
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab) || 0;

  return (
    <TabsTimelineSub
      tabs={tabs()}
      // current={'0'} 
      // setCurrent={'0'} 
      currentSubTab={currentSubTab} 
      customClass={'custom-tabs-timeline-sub'}
    />
  );
};

export default BasicInfoBeneficiary;